import { makeAutoObservable } from 'mobx';
import _ from 'lodash';

class RolesListState {
  store;
  history;

  roles;

  constructor(store, history) {
    makeAutoObservable(this, {
      store: false,
      history: false
    });

    this.store = store;
    this.history = history;
  }

  async load() {
    this.roles = await this.store.load();
  }

  async postRole() {
    const id = await this.store.postRole();
    this.history.push(`/permissions/${id}`);
  }

  async destroyRole(role) {
    await this.store.destroy(role);
    await this.load();
  }

  get defaultRoles() {
    return _.reject(this.roles, r => r.isCustom);
  }

  get customRoles() {
    return _.filter(this.roles, r => r.isCustom);
  }
}

export default RolesListState;
